import React from 'react';
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavDropdown from "react-bootstrap/NavDropdown";
import {HashRouter as Router, Link, Route, Routes} from "react-router-dom";
// import Admin from "../pages/Admin";
// import PhotoGallery from "../pages/PhotoGallery";
import {Contacts} from "../pages/Contacts";
import 'bootstrap/dist/css/bootstrap.min.css';
import {Home} from "../pages/Home";
import logo from "../images/logo.jpg"

function NavbarComponent() {
    return (
        <Router>
            <div>
                <Navbar className="NavbarComponent" data-bs-theme='light' expand="lg">
                    <Container>
                        <Navbar.Brand as={Link} to="/">
                            <img
                                alt="SSSS-Logo"
                                src={logo}
                                width="30"
                                height="30"
                            />
                            SSSS Vadtaldham - Chicago
                        </Navbar.Brand>
                        <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                        <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="me-auto">
                                <Nav.Link as={Link} to="/">Home</Nav.Link>
                                <NavDropdown title="Media" id="media-nav-dropdown">
                                    <NavDropdown.Item
                                        href="https://www.youtube.com/channel/UCwOjFGaZSgaVJuRqdh5h0SQ"
                                        target="blank">
                                        Youtube
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        href="https://www.instagram.com/ssss.chicago"
                                        target="blank">
                                        Instagram
                                    </NavDropdown.Item>
                                    {/*<NavDropdown.Item as={Link} to="/photoGallery">*/}
                                    {/*    Photo Gallery*/}
                                    {/*</NavDropdown.Item>*/}
                                </NavDropdown>
                                <NavDropdown title="Chapters" id="chapters-nav-dropdown">
                                    <NavDropdown.Item href="http://newyork.swaminarayan.us/" target="blank">
                                        New York
                                    </NavDropdown.Item>
                                </NavDropdown>
                                <Nav.Link as={Link} to="/contact">Contact Us</Nav.Link>
                                {/*<Nav.Link as={Link} to="/admin">Admin</Nav.Link>*/}
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </div>
            <div>
                <Routes>
                    {/*<Route path="/admin" element={<Admin/>}/>*/}
                    {/*<Route path="/photoGallery" element={<PhotoGallery/>}/>*/}
                    <Route path="/contact" element={<Contacts/>}/>
                    <Route path="/" element={<Home/>}/>
                </Routes>
            </div>
        </Router>
    );
}

export default NavbarComponent;
